import { render, staticRenderFns } from "./BorderRadius.vue?vue&type=template&id=9ddddcbe&"
import script from "./BorderRadius.vue?vue&type=script&lang=ts&"
export * from "./BorderRadius.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports